import { render, staticRenderFns } from "./wuliuList.vue?vue&type=template&id=4ad002b1&scoped=true&"
import script from "./wuliuList.vue?vue&type=script&lang=js&"
export * from "./wuliuList.vue?vue&type=script&lang=js&"
import style0 from "./wuliuList.vue?vue&type=style&index=0&id=4ad002b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad002b1",
  null
  
)

export default component.exports